import { converter } from '../../../masks/masks'
export default class Nfe {
  constructor(
    _id,
    empresa,
    chave,
    emitNome,
    destNome,
    emitCnpj,
    emitCpf,
    emitIe,
    destCnpj,
    destCpf,
    origem,
    protocolada,
    serie,
    status,
    tipo,
    transportados,
    ufOrigem,
    manifestacao,
    numero,
    valorCofins,
    valorIcms,
    valorPis,
    valorIpi,
    valorFcp,
    valorBcst,
    valor,
    dtImportacao,
    emissao,
    danfe,
    xmlCce,
    cte,
    customValues,
    duplicata,
    produtos,
    statusErp,
    ftpPython,
    ftpPythonPdf,
    logErroFtpXml,
    logErroFtpPdf,
    log_statusErp,
    id_fluig,
    log_statusErpDois,
    statusErpDois,
    docZip,
    natOp,
    inf_ad,
    verProc,
    data_erp,
    departamento,
    trans_cnpj,
    trans_nome,
    trans_pesoL,
    trans_pesoB,
    trans_esp,
    trans_qVol,
    trans_modFrete,
    posFechamento
    ) {
    // this.emissao = ,
    (this.emissao = new Date(emissao)),
      (this.numero = parseInt(numero)),
      (this.serie = serie),
      (this.emitNome = emitNome),
      (this.destNome = destNome),
      (this.valor = valor),
      (this.valorPis = valorPis),
      (this.valorIpi = valorIpi),
      (this.valorIcms = valorIcms),
      (this.valorCofins = valorCofins),
      (this.valorFcp = valorFcp),
      (this.valorBcst = valorBcst),

    emitCnpj != undefined && emitCpf != undefined
      ? (this.emitCnpj = `${emitCnpj} - ${emitCpf}`)
      : emitCnpj != undefined && emitCpf == undefined
      ? (this.emitCnpj = emitCnpj)
      : (this.emitCnpj = emitCpf);
    destCnpj != undefined && destCpf != undefined
      ? (this.destCnpj = `${destCnpj} - ${destCpf}`)
      : destCnpj != undefined && destCpf == undefined
      ? (this.destCnpj = destCnpj)
      : (this.destCnpj = destCpf);
    (this.chave = chave),
      (this.emitIe = emitIe),
      (this.origem = origem),
      (this.protocolada = protocolada),
      (this.status = status),
      (this.tipo = tipo);
    (this.transportados = transportados),
      (this.ufOrigem = ufOrigem),
      (this.manifestacao = manifestacao),
      (this.dtImportacao = new Date(dtImportacao)),
      (this.vinculo = ""),
      (this.duplicata = duplicata),
      (this.produtos = produtos),
      (this.statusErp = statusErp),
      (this.ftpPython = ftpPython),
      (this.ftpPythonPdf = ftpPythonPdf),
      (this.logErroFtpXml = logErroFtpXml),
      (this.logErroFtpPdf = logErroFtpPdf),
      (this.log_statusErp = log_statusErp),
      (this.id_fluig = id_fluig),
      (this.log_statusErpDois = log_statusErpDois),
      (this.statusErpDois = statusErpDois),
      (this.xmlCce = xmlCce),
      (this.cte = cte),
      (this.danfe = danfe),
      (this._id = _id),
      (this.empresa = empresa),
      (this.customValues = customValues),
      (this.docZip = docZip),
      (this.natOp = natOp),
      (this.inf_ad = inf_ad),
      (this.verProc = verProc),
      (this.data_erp = converter(data_erp)),
      (this.departamento = departamento),
      (this.trans_cnpj = trans_cnpj),
      (this.trans_nome = trans_nome),
      (this.trans_pesoL = trans_pesoL),
      (this.trans_pesoB = trans_pesoB),
      (this.trans_esp = trans_esp),
      (this.trans_qVol = trans_qVol),
      (this.trans_modFrete = trans_modFrete),
      (this.posFechamento = posFechamento)
  }
}



// WEBPACK FOOTER //
// ./src/domain/notas/nfe/Nfe.js